<template>
  <crud-form
    v-model="getPayload"
    :request-class="requestClass"
    :page-title="pageTitle"
    :total-group="1"
    navigate-back-route="pos.list"
    :override-create-payload="overrideCreatePayload"
  >
    <template slot="group-1">
      <form-group v-if="!isEdit">
        <v-row align="start">
          <v-col cols="9">
            <input-radio
              v-model="savePayload.indHabilitaRemocaoTroca"
              :options="indHabilitaRemocaoTrocaOptions"
              label="Habilitar troca"
              :loading="loading"
              row
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-combobox
              id="input:idModeloTerminalPos"
              v-model="savePayload.idModeloTerminalPos"
              label="Modelo"
              outlined
              :loading="loadingModels"
              clearable
              :disabled="idModeloTerminalPosOptions.length < 1"
              :items="idModeloTerminalPosOptions"
            />
          </v-col>
          <v-col cols="6">
            <input-text
              id="input:numSerie"
              v-model="savePayload.numSerie"
              label="Número de série"
              :rules="[requiredRule]"
              outlined
              :loading="loading"
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:codTerminalSgv"
              v-model="savePayload.codTerminalSgv"
              label="Código terminal SGV"
              outlined
              :loading="loading"
            />
          </v-col>
          <v-col cols="6">
            <input-text
              id="input:txtIdTerminalType"
              v-model="savePayload.txtIdTerminalType"
              label="ID Terminal"
              outlined
              :loading="loading"
            />
          </v-col>
        </v-row>
      </form-group>
      <form-group v-else>
        <v-row align="start">
          <v-col cols="9">
            <input-radio
              v-model="editPayload.indHabilitaRemocaoTroca"
              :options="indHabilitaRemocaoTrocaOptions"
              label="Habilitar troca"
              :loading="loading"
              row
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:codTerminalSgv"
              v-model="editPayload.codTerminalSgv"
              label="Cod. Terminal SGV"
              outlined
              disabled
              :loading="loading"
            />
          </v-col>
          <v-col cols="6">
            <input-text
              id="input:versaoAtualApp"
              v-model="editPayload.versaoAtualApp"
              label="Versão atual do APP"
              outlined
              disabled
              :loading="loading"
            />
          </v-col>
        </v-row>
        <v-row align="start">
          <v-col cols="6">
            <input-text
              id="input:numIccidChip"
              v-model="editPayload.numIccidChip"
              label="ID Chip"
              outlined
              disabled
              :loading="loading"
            />
          </v-col>
          <v-col cols="6">
            <input-text
              v-model="editPayload.loja.nomLoja"
              label="Loja"
              outlined
              disabled
              :loading="loading"
            />
          </v-col>
          <v-col cols="6">
            <input-text
              v-model="editPayload.loja.numCnpj"
              label="CNPJ"
              outlined
              disabled
              :loading="loading"
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from '@/app/arch/components/crud/CrudForm.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import PosModelRequest from 'Modules/contacard/terminal/model/PosModelRequest';
import RequestSelectMixin from '@/app/arch/mixins/RequestSelectMixin';
import PosRequest from './PosRequest';

export default {
  name: 'PosCrudForm',
  components: { CrudForm, FormGroup },
  mixins: [RulesMixin, RequestSelectMixin],
  data: () => ({
    requestClass: PosRequest,
    requestModels: PosModelRequest,
    loading: false,
    loadingModels: false,
    faultModelsError: 'Falha ao buscar listagem de modelos de terminais!',
    savePayload: {
      idModeloTerminalPos: '',
      txtIdTerminalType: '',
      numSerie: '',
      codTerminalSgv: '',
      indHabilitaRemocaoTroca: false,
    },
    editPayload: {
      codTerminalSgv: '',
      versaoAtualApp: '',
      numIccidChip: '',
      indHabilitaRemocaoTroca: '',
      loja: {
        nomLoja: '',
        numCnpj: '',
      },
    },
    idModeloTerminalPosOptions: [],
    indHabilitaRemocaoTrocaOptions: [
      {
        value: true,
        label: 'Sim',
      },
      {
        value: false,
        label: 'Não',
        color: 'primary',
      },
    ],
  }),
  computed: {
    getPayload: {
      get() {
        if (this.isEdit) {
          return this.editPayload;
        }
        return this.savePayload;
      },
      set(value) {
        if (this.isEdit) {
          this.editPayload = value;
        } else {
          this.savePayload = value;
        }
      },
    },
    isEdit() {
      const { id } = this.$route.params;
      return Number(id) >= 1;
    },
    pageTitle() {
      if (this.isEdit) {
        return 'Editar terminal';
      }
      return 'Adicionar terminal';
    },
  },
  created() {
    this.getModels();
  },
  methods: {
    getModels() {
      this.handleLoadingModels();
      this.makeModelsRequest();
    },
    handleLoadingModels() {
      this.loadingModels = !this.loadingModels;
    },
    makeModelsRequest() {
      this.serviceCall(
        this.requestModels.list(
          this.makeParams(),
        ),
        this.setDataOptions('idModeloTerminalPosOptions', 'nomModeloTerminalPos'),
        this.faultModelsError,
        this.handleLoadingModels,
      );
    },
    overrideCreatePayload(payload = {}) {
      return {
        ...payload,
        idModeloTerminalPos: payload.idModeloTerminalPos.value,
      };
    },
  },
  provide() {
    return {
      setDataLoading: (bool) => {
        this.loading = bool;
      },
    };
  },
};
</script>
